// @ts-nocheck
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const getLoginStatus = () => {
  const items = localStorage.getItem("LoginStatus");
  return items;
};

export const LoginCheck = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (getLoginStatus() === null || getLoginStatus() === false) {
      navigate("/login");
    } 
  });
};

export const setLoginStatus = (data) => {
  try {
    localStorage.setItem("LoginStatus", data);
  } catch (err) {
    console.log(err);
  }
};
